export { default as LoyaltyBanner } from './loyalty-banner';
